module.exports = __webpack_public_path__ + "img/5bade0d14f153dc0482890a1714c3102.fe075487.png";